import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MICE_CONSTANTS } from 'AppConstants';
import MetaTags from 'common/metaTags';
import BannerCarousel from './components/BannerCarousel/BannerCarousel';
import Offer from './components/Offer/Offer';
import HowItWork from './components/HowItWork/HowItWork';
import WhyChooseMmt from './components/WhyChooseMmt/WhyChooseMmt';
import OurClient from './components/OurClient/OurClient';
import { logPageLoadEvents } from 'omnitures';
import Testimonial from './components/Testimonial/Testimonial';
import DisplayContext from 'UtilityComponents/displayContext';
import GetQuote from './components/GetQuoteDropQuery/index';
import StatusPopup from 'common/statusPopup/statusPopup';
import { successPopupContent, MODAL_TYPE } from './config';
import { APPLICATION_CONSTANTS } from 'AppConstants';
import { showModal } from 'reduxStore/actions/miceActionDispatcher';
import HotelSearch from './components/HotelSearch/HotelSearch';
import { chooseMmtBusinessData, portfolioData, bannerCarouselData, SideBannerUrl } from './config';
import TermsAndConditionsModal from './components/HotelSearch/components/TermsAndConditionsModal/TermsAndConditionsModal';

const MiceApp = () => {
	const dispatch = useDispatch();
	const apiLoader = useSelector((state) => state.mice.apiLoader);
	const apiStatus = useSelector((state) => state.mice.apiStatus);
	const metaData = useSelector((state) => state.mice.metaData);
	const openModal = useSelector((state) => state.mice.openModal) || '';

	const displayName = useContext(DisplayContext).isMobile;
	const isMobileView = displayName == 'mobile';

	useEffect(() => {
		logPageLoadEvents(MICE_CONSTANTS.PAGE_NAME);
	}, []);

	const closeModal = () => {
		let payload = {
			modalType: ''
		};
		dispatch(showModal(payload));
	};

	const renderPopups = (openModal) => {
		switch (openModal) {
			case MODAL_TYPE.QUERY_FORM:
				return <GetQuote closeForm={closeModal} isMobile={isMobileView} apiLoader={apiLoader} />;
			case MODAL_TYPE.SUBMISSION_MODAL:
				return (
					<StatusPopup
						heading={apiStatus === APPLICATION_CONSTANTS.SUCCESS ? MICE_CONSTANTS.SUCCESS_HEADING : MICE_CONSTANTS.ERROR_HEADING}
						isFooter={apiStatus === APPLICATION_CONSTANTS.SUCCESS}
						showContent={apiStatus === APPLICATION_CONSTANTS.SUCCESS}
						content={apiStatus === APPLICATION_CONSTANTS.SUCCESS && successPopupContent}
						handleModal={closeModal}
						apiStatus={apiStatus}
					/>
				);
			case MODAL_TYPE.T_AND_C:
				return (<TermsAndConditionsModal closeModal={closeModal} />);
		}
	};

	return (
		<>
			<MetaTags {...metaData} />
			<BannerCarousel config={{ bannerCarouselData, SideBannerUrl }} />
			<HotelSearch />
			<Offer />
			<HowItWork />
			<WhyChooseMmt chooseMmtBusinessData={chooseMmtBusinessData} portfolioData={portfolioData} />
			<Testimonial />
			<OurClient />
			{renderPopups(openModal)}
		</>
	);
};

export default MiceApp;
